import { useEffect, useState } from "react";
import { useGetAddressListQuery } from "../../store/api/addressapi";
import { useGetCartProductQuery, useGetCountriesQuery, useGetShippingChargeMutation } from "../../store/api/cartapi";
import Voucher from "./Feature/Voucher";
import Coupon from "./Feature/Coupon";
import Credit from "./Feature/Credit";
import { gettoken, getvoucher } from "../../Localstorage/Store";
import axios from "axios";

const Cart = () => {
  const tokenvalue = gettoken();
  const localvouhcer = getvoucher();
  const [featureType, setFeatureType] = useState(null);
  const [addressInfo, setAddressInfo] = useState({ list: [], default: 0, country: [] });
  const [shippingInfo, setShippingInfo] = useState({ price: null, defaultShip: null,Error:false });


  const [getShippingCharge] = useGetShippingChargeMutation();
  const { data: countryData, isLoading: countryLoading } = useGetCountriesQuery();
  const { data: cartData, isLoading: cartLoading, refetch: cartRefetch } = useGetCartProductQuery();
  const { data: addressData, isLoading: addressLoading, refetch: addressRefetch } = useGetAddressListQuery();
 
 
 
   const fetchShipping = async (pin,defaultShip) => {
    const response = await getShippingCharge({ "pin_code": pin });
    if(response?.error){
      return setShippingInfo({
            defaultShip,
            price: null,
            Error: true
    });
        
    };
    return setShippingInfo({
            defaultShip,
            price: response.data.total_rate,
            Error: false
          });

  };

  const handleAddressChange = async (newDefaultId) => {
    try {
      const { data: updatedAddresses } = await addressRefetch();
      const newDefaultAddress = updatedAddresses.find(item => item.id === newDefaultId);

      if (newDefaultAddress) {
        setAddressInfo({
          list: updatedAddresses,
          default: newDefaultId,
          country: countryData,
          refetch: addressRefetch
        });

        if (newDefaultAddress.postcode) {
          const rate = await fetchShipping(newDefaultAddress.postcode);
        }
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

   const applyvoucher = async () => {
      try {
        const config = {headers: {Authorization: `Bearer ${tokenvalue.access}`}};
        let url = `${process.env.REACT_APP_API_URL}cartapi/assign-voucher/`;
        const response = await axios.post(url, {"vouchercode":localvouhcer}, config);
          if(response.data?.code){
            cartRefetch();
          }
      } catch (error) { }
    };

  useEffect(()=>{
  if(localvouhcer){

  }
  },[localvouhcer])

  useEffect(() => {
    if (!cartLoading && cartData) {
      const voucher = cartData.voucher_list[0];
      if(!voucher && localvouhcer){
        applyvoucher();
      }
      const type = !voucher ? "Credit" : voucher.offer_type === "Coupon" ? "Coupon" : "Voucher";
      setFeatureType(type);

      if (!addressLoading && addressData && !countryLoading) {
      setAddressInfo({ list: addressData, default: addressData[0].id, country: countryData, refetch: addressRefetch });
      if (addressData[0]?.postcode) {
        fetchShipping(addressData[0].postcode,cartData.total_shiping_charge);
      }
    }
    }
  }, [cartLoading, cartData,addressData, addressLoading, getShippingCharge]);


  const commonProps = {
    cartInfo: { cartData, cartRefetch },
    popup: {},
    address: addressInfo,
    shippingCharges: shippingInfo,
    onAddressChange: handleAddressChange
  };
  const FeatureComponents = {
    Voucher: <Voucher {...commonProps} />,
    Coupon: <Coupon {...commonProps} />,
    Credit: <Credit {...commonProps} />
  };

  if (cartLoading) return null;
  return <>{FeatureComponents[featureType]}</>
};

export default Cart;